export const NavBarEvents = {
  Config:'config',
    Save: 'save',
    Preview: 'preview',
    Test: 'test',
    Submit: 'submit'
}